import $ from 'jquery';

$( () => {
  const showAll = document.querySelector( '#show-all' )

  const selectAll = document.querySelectorAll('.hidden-content')

  $( showAll ).on( 'click', () => {
    $( '.hidden-content.hide' ).length ? $('.show-hide-text').html('View Less') : $('.show-hide-text').html('View All')
    $( '.hidden-content.hide' ).length 
      ? $( '.hidden-content.hide' ).slice( 0, $( '.hidden-content.hide' ).length ).removeClass( 'hide' ) 
      : selectAll.forEach((element, index ) => {
          if(index >= 6) {
            element.classList.add( 'hide' )
          }
        }); 
  })

});
